const data = {
	"width": 20,
	"height": 20,
	"body": "<path fill=\"currentColor\" d=\"M5.797 7a1 1 0 0 0-.778 1.628l3.814 4.723a1.5 1.5 0 0 0 2.334 0l3.815-4.723A1 1 0 0 0 14.204 7H5.797Z\"/>"
};
exports.__esModule = true;
exports.default = data;
